  
<template >
  <div class="pageContent" @click='showAdd=false'>
    <pageTitle title='发票管理' @rightHandler='showAdd = !showAdd' :showRight='true' rightTitle='新增'/>
    <mu-paper class="addList" v-if='showAdd'>
      <mu-menu>
        <mu-menu-item title="普通个人发票" v-on:click="OpenDetails(1,null , true)" />
        <mu-menu-item title="普通公司发票" v-on:click="OpenDetails(2,null , true)" />
        <mu-menu-item title="增值税专用发票" v-on:click="OpenDetails(3,null , true)" />
      </mu-menu>  
    </mu-paper>
    <div style=" width:100% " align="center" v-show="  IsLoading  ">
      <img src="../../../static/LoadingBest.gif" style=" width:1.2rem ; margin:2.1rem auto 0 auto" />
    </div>

    <div v-show="  !IsLoading  " v-for=" item in InvoiceInfo">
      <mu-paper class="demo-paper" v-if=" item.InvoiceType == '增值税普通发票'  &&  item.InvoiceProperty == '个人'  ">
        <div style=" width:90%  ; padding-top:0.3rem; margin:auto ">

          <div style=" padding-bottom:0.1rem ;  overflow:hidden ; zoom:1; ">
            <div style="font-size:0.32rem ;color:#666666 ; font-weight:bold ; float:left ;  ">
              增值税普通发票 - 个人
            </div>
            <div style="width:1rem ; float:right " align="center" v-on:click="OpenDetails(1,item , false)">
              <img src="../../../static/user/编辑.png" style="width:0.5rem ;  margin-top:  0rem " />
            </div>
          </div>
          <div style="font-size:0.26rem ; line-height: 1.6 ; padding-bottom:0.3rem" align="left">
            抬头： {{item.Name}}
          </div>

        </div>
      </mu-paper>

      <mu-paper class="demo-paper" v-if=" item.InvoiceType == '增值税普通发票'  &&  item.InvoiceProperty == '公司' ">
        <div style=" width:90%  ; padding-top:0.3rem ; margin:auto ">

          <div style=" padding-bottom:0.1rem ;  overflow:hidden ; zoom:1; ">
            <div style="font-size:0.32rem ;color:#666666 ; font-weight:bold ; float:left ;  ">
              增值税普通发票 - 公司
            </div>
            <div style="width:1rem ; float:right " align="center" v-on:click="OpenDetails(2,item, false)">
              <img src="../../../static/user/编辑.png" style="width:0.5rem ;  margin-top:  0rem " />
            </div>
          </div>

          <div style="font-size:0.26rem ; line-height: 1.6 ; padding-bottom:0.3rem" align="left">
            <div style="padding-bottom: 0rem ; ">
              抬头： {{item.Name}}
            </div>
            <div style="padding-bottom: 0rem ; ">
              税号： {{item.IndentityNo}}
            </div>
          </div>

        </div>
      </mu-paper>

      <mu-paper class="demo-paper" v-if=" item.InvoiceType == '增值税专用发票'  ">
        <div style=" width:90%  ; padding-top:0.3rem; margin:auto ">

          <div style=" padding-bottom:0.1rem ;  overflow:hidden ; zoom:1; ">
            <div style="font-size:0.32rem ;color:#666666 ; font-weight:bold ; float:left ;  ">
              增值税专用发票
            </div>
            <div style="width:1rem ; float:right " align="center" v-on:click="OpenDetails(3, item, false)">
              <img src="../../../static/user/编辑.png" style="width:0.5rem ;  margin-top:  0rem " />
            </div>
          </div>

          <div style="font-size:0.26rem ; line-height: 1.6 ; padding-bottom:0.3rem" align="left">
            <div style=" ; ">
              抬头： {{item.Name}}
            </div>
            <div style=" ; ">
              税号： {{item.IndentityNo}}
            </div>
            <div style=" ; ">
              电话： {{item.Phone}}
            </div>
            <div style=" ; ">
              地址： {{item.Address}}
            </div>
            <div style=" ; ">
              开户行： {{item.BankName}}
            </div>
            <div style=" ; ">
              账号： {{item.BankAccountNo}}
            </div>
          </div>
        </div>
      </mu-paper>

    </div>

    <!--列表尾巴-->
    <loadListTail mainTitle='暂时没有发票记录！' mainIcon='noInvoice' :extendBtn='true' btnText='新增发票' @btnHandler='showAdd = !showAdd' :noMore='true' :isLoading='IsLoading' :overZero='InvoiceInfo.length > 0'  />
    <br />
    <br />
    <br />
    <br />

    <!--弹出框 选择是否  个人发票模块-->
    <mu-dialog :open="personalwindow" @close="closeNO">
      <div style="color:#666666 ; margin: -0.2rem 0 0.25rem 0 ; font-size: 0.32rem ;font-weight:700  " align="center">
        增值税普通发票 - 个人
      </div>
      <mu-divider style="width:120vw ; margin-left:-10vw" />

      <div style="margin:0.3rem 0 0.3rem 0 ;overflow:hidden ; zoom:1;">
        <div style=" color:#333333 ; font-size:0.28rem ; float:left ; margin-top: 0.1rem ">
          抬头:
        </div>
        <div style="   float:right ; height:0.28rem ;font-size:0.25rem ;">
          <input v-model='InvoiceItem.Name' style=" color:#999999 ;width:3.7rem ; border:none ;height:0.6rem ;  outline:none; " />
        </div>
      </div>

      <table style="width:100%">
        <tr>
          <td align="center">
            <mu-flat-button slot="actions" @click="closeNO" label="取消" style="background-color:#cccccc ;color:white ; width:100% " />
          </td>
          <td align="center">
            <mu-flat-button slot="actions" @click="closeYES(1,InvoiceItem)" label="确定" style="background-color:#27BA69 ;;color:white ; width:100%  " />
          </td>
        </tr>
      </table>
      <div align="center" style="margin:2vh 0 1vh 0" v-on:click="CheckDelete( InvoiceItem)" v-if="InvoiceItem.Name != undefined ">
        <u style="color:#ff5a5a ; "> 删除发票信息 </u>
      </div>
    </mu-dialog>
    <!--弹出框 选择是否  个人发票模块  END-->

    <!--弹出框 选择是否  公司  -->
    <mu-dialog :open="companywindow" title="" @close="closeNO">
      <div style="color:#666666 ; margin: -0.2rem 0 0.25rem 0 ; font-size: 0.32rem ;font-weight:700  " align="center">
        增值税普通发票 - 公司
      </div>
      <mu-divider />

      <div style="margin:0.2rem 0 0.2rem 0 ;overflow:hidden ; zoom:1;">
        <div style=" color:#333333 ; font-size:0.28rem ; float:left ; margin-top: 0.1rem ">
          抬头:
        </div>
        <div style="   float:right ; height:0.28rem ;font-size:0.25rem ;">
          <input v-model='InvoiceItem.Name' style=" color:#999999 ;width:3.7rem ; border:none ;height:0.6rem ;  outline:none; " />
        </div>
      </div>
      <mu-divider />

      <div style="margin:0.2rem 0 0.2rem 0 ;overflow:hidden ; zoom:1;">
        <div style=" color:#333333 ; font-size:0.28rem ; float:left ; margin-top: 0.1rem ">
          税号:
        </div>
        <div style="   float:right ; height:0.28rem ;font-size:0.25rem ;">
          <input v-model='InvoiceItem.IndentityNo' style=" color:#999999 ;width:3.7rem ; border:none ;height:0.6rem ;  outline:none; " />
        </div>
        <!--   v-on:keypress="CheckNum($event)" -->
      </div>
      <mu-divider />

      <table style="width:100%">
        <tr>
          <td align="center">
            <mu-flat-button slot="actions" @click="closeNO" label="取消" style="background-color:#cccccc ;color:white ; width:100% " />
          </td>
          <td align="center">
            <mu-flat-button slot="actions" @click="closeYES(2,InvoiceItem )" label="确定" style="background-color:#27BA69 ;;color:white ; width:100%  " />
          </td>
        </tr>
      </table>
      <div align="center" style="margin:2vh 0 1vh 0" v-on:click="CheckDelete( InvoiceItem)" v-if="InvoiceItem.Name != undefined ">
        <u style="color:#ff5a5a ; "> 删除发票信息 </u>
      </div>
    </mu-dialog>
    <!--弹出框 选择是否  公司  end  -->

    <!--弹出框 选择是否  增值税专用发票-->
    <mu-dialog :open="specialwindow" title="" @close="closeNO">
      <div style="color:#666666 ; margin-bottom:2vh ; font-size:120% ;font-weight:700 ; " align="center">
        增值税专用发票
      </div>
      <mu-divider />

      <div style="margin:0.2rem 0 0.2rem 0 ;overflow:hidden ; zoom:1;">
        <div style=" color:#333333 ; font-size:0.28rem ; float:left ; margin-top: 0.1rem ">
          抬头:
        </div>
        <div style="   float:right ; height:0.28rem ;font-size:0.25rem ;">
          <input v-model='InvoiceItem.Name' style=" color:#999999 ;width:3.7rem ; border:none ;height:0.6rem ;  outline:none; " />
        </div>
      </div>
      <mu-divider />

      <div style="margin:0.2rem 0 0.2rem 0 ;overflow:hidden ; zoom:1;">
        <div style=" color:#333333 ; font-size:0.28rem ; float:left ; margin-top: 0.1rem ">
          税号:
        </div>
        <div style="   float:right ; height:0.28rem ;font-size:0.25rem ;">
          <input v-model='InvoiceItem.IndentityNo' style=" color:#999999 ;width:3.7rem ; border:none ;height:0.6rem ;  outline:none; " />
        </div>
      </div>
      <mu-divider />

      <div style="margin:0.2rem 0 0.2rem 0 ;overflow:hidden ; zoom:1;">
        <div style=" color:#333333 ; font-size:0.28rem ; float:left ; margin-top: 0.1rem ">
          电话:
        </div>
        <div style="   float:right ; height:0.28rem ;font-size:0.25rem ;">
          <input v-model='InvoiceItem.Phone' v-on:keypress="CheckNum($event)" style=" color:#999999 ;width:3.7rem ; border:none ;height:0.6rem ;  outline:none; " />
        </div>
      </div>
      <mu-divider />

      <div style="margin:0.2rem 0 0.2rem 0 ;overflow:hidden ; zoom:1;">
        <div style=" color:#333333 ; font-size:0.28rem ; float:left ; margin-top: 0.1rem ">
          地址:
        </div>
        <div style="   float:right ; height:0.28rem ;font-size:0.25rem ;">
          <input v-model='InvoiceItem.Address' style=" color:#999999 ;width:3.7rem ; border:none ;height:0.6rem ;  outline:none; " />
        </div>
      </div>
      <mu-divider />

      <div style="margin:0.2rem 0 0.2rem 0 ;overflow:hidden ; zoom:1;">
        <div style=" color:#333333 ; font-size:0.28rem ; float:left ; margin-top: 0.1rem ">
          开户行
        </div>
        <div style="   float:right ; height:0.28rem ;font-size:0.25rem ;">
          <input v-model='InvoiceItem.BankName' style=" color:#999999 ;width:3.5rem ; border:none ;height:0.6rem ;  outline:none; " />
        </div>
      </div>
      <mu-divider />

      <div style="margin:0.2rem 0 0.2rem 0 ;overflow:hidden ; zoom:1;">
        <div style=" color:#333333 ; font-size:0.28rem ; float:left ; margin-top: 0.1rem ">
          账号:
        </div>
        <div style="   float:right ; height:0.28rem ;font-size:0.25rem ;">
          <input v-model='InvoiceItem.BankAccountNo' v-on:keypress="CheckNum($event)" style=" color:#999999 ;width:3.7rem ; border:none ;height:0.6rem ;  outline:none; " />
        </div>
      </div>
      <mu-divider />

      <table style="width:100% ; margin-top:0.1rem">
        <tr>
          <td align="center">
            <mu-flat-button slot="actions" @click="closeNO" label="取消" style="background-color:#cccccc ;color:white ; width:100% " />
          </td>
          <td align="center">
            <mu-flat-button slot="actions" @click="closeYES(3,InvoiceItem )" label="确定" style="background-color:#27BA69 ;;color:white ; width:100%  " />
          </td>
        </tr>
      </table>
      <div align="center" style="margin:2vh 0 1vh 0" v-on:click="CheckDelete( InvoiceItem )" v-if="InvoiceItem.Name != undefined ">
        <u style="color:#ff5a5a ; "> 删除发票信息 </u>
      </div>
    </mu-dialog>
    <!--弹出框 选择是否  增值税专用发票 end  -->

    <!--弹出框 选择是否  删除模块-->
    <mu-dialog :open="deletewindow" title="" @close="closeNO(-1)">
      <div style="color:#666666 ; margin-bottom:1.5vh">
        您真的要删除这份发票记录吗？
      </div>
      <table style="width:100%">
        <tr>
          <td align="center">
            <mu-flat-button slot="actions" @click="closeNO(-1)" label="取消" style="background-color:#cccccc ;color:white  " />
          </td>
          <td align="center">
            <mu-flat-button slot="actions" @click="closeYES(-1)" label="确定" style="background-color:#27BA69 ;;color:white " />
          </td>
        </tr>
      </table>
    </mu-dialog>
    <!--弹出框-->
    <mu-toast v-if="toast" v-bind:message="TellUser" @close="hideToast" id="alertline" />
    <!--弹出框 选择是否  删除模块   END  -->

    <div style="background-color: #F5F5F5;min-height:2rem"> </div>

  </div>
</template>








<script>

import { mapMutations, mapGetters } from 'vuex'
import loadListTail from '../../components/loadListTail'
import api from '../../api'


export default {
  data() {

    return {

      IsLoading: true,
      cardno: '',

      // 弹出层
      toast: false,
      TellUser: '',
      // 弹出标签 选择是否
      personalwindow: false,
      companywindow: false,
      specialwindow: false,
      deletewindow: false,
      //右上角按钮
      bottomSheet: false,
      iconclass1: { size: 36 },
      //右上角按钮  end

      // 全部发票信息
      InvoiceInfo: '',

      // 独立ID
      IsInsert: false,
      InvoiceItem: { Address: "", BankAccountNo: "", BankName: "", IndentityNo: "", InvoiceId: -1, InvoiceProperty: "", InvoiceType: "", Name: "", Phone: "" },
      ItemID: '',

      // 弹出层 弹出内容
      toast: false,
      TellUser: '',
      // 弹出层 弹出内容  END
      //是否显示添加选择框
      showAdd:false
    }
  },
  components: {
    //列表尾巴组件
    loadListTail
  },
  computed: {
    ...mapGetters([
      'g_UserInfo',
    ]),

  },

  activated() {

    this.IsLoading = true;
    this.InvoiceInfo = '';
    this.GetMyInvoice();
  },
  methods: {

    // 验证用户按下的按键
    CheckNum(e) {
      // 　　if (!String.fromCharCode(e.keyCode).match(/[0-9\.]/)) {
      if (!String.fromCharCode(e.keyCode).match(/[0-9]/)) {
        e.returnValue = false;
        e = null;
        return null;
      }
    },




    // 后退一页
    goback() {
      javascript: history.go(-1);
    },






    // 获取发票信息
    GetMyInvoice() {

      var params = new this.URLSearchParam();

      this.$http.post(api.GetMyInvoice(), ).then((res) => {

        if (res.Result) {
          this.InvoiceInfo = res.Data;
          this.IsLoading = false;
        }
        else {
          this.TellUser = res.Message;
          this.showToast();
        }

      });
    },

    InsertMemberInvoiceInfo(type, val) {
      if (type == 1) {
        val.InvoiceType = "增值税普通发票";
        val.InvoiceProperty = "个人";

        if (val.Name == undefined || val.Name.trim() == "") {
          this.TellUser = "请完善信息";
          this.showToast();
          return
        }
      }
      if (type == 2) {
        val.InvoiceType = "增值税普通发票";
        val.InvoiceProperty = "公司";

        if (val.Name == undefined || val.Name.trim() == "" || val.IndentityNo == undefined || val.IndentityNo.trim() == "") {
          this.TellUser = "请完善信息";
          this.showToast();
          return
        }
      }
      if (type == 3) {
        val.InvoiceType = "增值税专用发票";
        val.InvoiceProperty = "公司";


        if (val.Name == undefined || val.Name.trim() == "" || val.IndentityNo == undefined || val.IndentityNo.trim() == "" ||
          val.Phone == undefined || val.Phone.trim() == "" || val.Address == undefined || val.Address.trim() == "" ||
          val.BankName == undefined || val.BankName.trim() == "" || val.BankAccountNo == undefined || val.BankAccountNo.trim() == ""
        ) {
          this.TellUser = "请完善信息";
          this.showToast();
          return
        }
      }

      // 只有完成了才把窗口关掉
      this.personalwindow = false;
      this.companywindow = false;
      this.specialwindow = false;


      var params = new this.URLSearchParam();
      params.append('invoiceType', val.InvoiceType);
      params.append('invoiceProperty', val.InvoiceProperty);

      params.append('name', val.Name);
      params.append('indentityNo', val.IndentityNo);
      params.append('phone', val.Phone);
      params.append('address', val.Address);
      params.append('bankName', val.BankName);
      params.append('bankAccountNo', val.BankAccountNo);
      params.append('bankAccountNo', val.BankAccountNo);
      params.append('InvoiceId', this.InvoiceItem.InvoiceId);


      if (this.IsInsert == false) {
        this.$http.post(api.UpdateMemberInvoiceInfo(), params.toParam()).then((res) => {
          if (res.Result) {
            //调用弹出层
            this.TellUser = res.Data;
            this.showToast();

            this.GetMyInvoice()
          }
          else {
            this.TellUser = res.Message;
            this.showToast();
          }
        });
      }
      else {
        this.$http.post(api.InsertMemberInvoiceInfo(), params.toParam()).then((res) => {
          if (res.Result) {
            //调用弹出层
            this.TellUser = res.Data;
            this.showToast();

            this.GetMyInvoice()
          }
          else {
            this.TellUser = res.Message;
            this.showToast();
          }
        });
      }

    },


    //右上角按钮
    closeBottomSheet() {
      this.bottomSheet = false
    },
    openBottomSheet() {
      this.bottomSheet = true
    },
    //右上角按钮  end






    // 弹出层
    showToast() {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 1000)
      if (this.TellUser == '未登录') {
        this.$http.post(api.LogOff()).then((res) => { });
        this.$store.dispatch('clearUser');
        this.toastTimer = setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 1200)
      }
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    // 弹出层  end

    // 弹出标签 选择是否
    // 新增发票，三种
    OpenDetails(type, data, Insert) {
      // type  跳出来的框的样子
      this.showAdd = false
      if (data == undefined) {
        data = { Address: "", BankAccountNo: "", BankName: "", IndentityNo: "", InvoiceId: -1, InvoiceProperty: "", InvoiceType: "", Name: "", Phone: "" }
      }

      this.IsInsert = Insert;

      console.log('IsInsert：' + this.IsInsert)

      this.InvoiceItem = data;

      if (type == 1) {
        this.personalwindow = true;
      }
      else if (type == 2) {
        this.companywindow = true;
      }
      else if (type == 3) {
        this.specialwindow = true;
      }
    },

    CheckDelete(data) {
      this.deletewindow = true;
      this.ItemID = data.InvoiceId;
    },

    closeYES(type, data) {

      if (type == -1) {
        // 删除
        var params = new this.URLSearchParam();
        params.append('invoiceId', this.ItemID);
        this.$http.post(api.DeleteInvoice(), params.toParam()).then((res) => {
          this.deletewindow = false;

          this.personalwindow = false;
          this.companywindow = false;
          this.specialwindow = false;
          this.GetMyInvoice()

          //调用弹出层
          this.TellUser = '成功删除';
          this.showToast();
        });


      }
      else {
        // this.personalwindow = false;
        // this.companywindow = false;
        // this.specialwindow = false;

        this.InsertMemberInvoiceInfo(type, data);

      }

    },


    //  拒绝取消订单
    closeNO(val) {
      if (val == -1) {
        this.deletewindow = false;
      }
      else {
        this.personalwindow = false;
        this.companywindow = false;
        this.specialwindow = false;
      }
      this.GetMyInvoice();
    },

    // END 弹出标签 选择是否,
  }
}



</script>






<style lang="less" scoped="">
@import "../../assets/theme.less";


#greenfont {
  color: @primaryColor ;
}

.pageContent {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;

  background-color: #F5F5F5;

  min-height: 100vh;
}

.demo-paper {
  width: 92%;
  margin: 0.2rem auto 0 auto;
  box-shadow: 0px 7px 18px #e2e2e2;
}

.addList{
  display: inline-block;
  position: absolute;
  right: 0.1rem;
  top:0.7rem;
}
</style>





// WEBPACK FOOTER //
// InvoiceManage.vue?35099148